import api from "../../axiosConfig";

export const adddoctor = async (formData) => {
    try {

      const response = await api.post('/doctor/add-doctor', formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success' || resData?.message_type === 'success') {
        return { success: true, data: resData };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };

  export const getdoctor = async () => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get('/doctor/all-doctor', {
      
    });

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success' || resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching doctors');
  }
};



export const updatedoctor = async (id, formData) => {
  const token = sessionStorage.getItem('token');

  // Append required format values
  const payload = {
    ...formData,
    id: parseInt(id),
    _method: 'put', // Required for Laravel-style method spoofing
  };
  console.log('Payload for update:', payload);

  try {
    const response = await api.post(`/doctor/update-doctor/${id}`, payload, {
     
    });

    const resData = response?.data;
    console.log('Update doctor response:', resData);

    if (resData?.success_type === 'success' || resData?.message_type === 'success') {
      return { success: true, data: resData };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error updating hospital');
  }
};